import { render } from "./WiringColor.vue?vue&type=template&id=1a9e36bd&scoped=true"
import script from "./WiringColor.vue?vue&type=script&lang=js"
export * from "./WiringColor.vue?vue&type=script&lang=js"

import "./WiringColor.vue?vue&type=style&index=0&id=1a9e36bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9e36bd"]])

export default __exports__